import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SpinnerComponent } from './spinner.component';
import { AuthenticationService, SpinnerService } from './services';
import { User } from './models';
import { NgxPermissionsService } from 'ngx-permissions';
import { JwtHelperService } from '@auth0/angular-jwt';

@Component({
    selector: 'body',
    template: '<spinner-component></spinner-component><router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {
    currentUser: User;

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private permissionsService: NgxPermissionsService
       
    ) {
        this.authenticationService.currentUser.subscribe(x => this.currentUser = x);

    }


    // logout() {
    //     this.authenticationService.logout();
    //     this.router.navigate(['/login']);
    // }

    ngOnInit() {
        var user = this.authenticationService.getAuthorizationToken();
        const helper = new JwtHelperService();
        const decodedToken = helper.decodeToken(user);
        // var role = new Array(decodedToken.role)
        if (decodedToken) {
            if (Array.isArray(decodedToken.role)) {
                this.permissionsService.loadPermissions(decodedToken.role);
            }
            else {
                this.permissionsService.loadPermissions([decodedToken.role]);
            }
        }
        // if (user) {
        //      this.router.navigate(['/dealer/home']);
        // }
        // else {
        //     this.router.navigate(['/login']);
        // }

    }
}